import * as React from 'react';
import { useCallback } from 'react';

import { useSlate, useSlateStatic } from 'slate-react';

import { BoldIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';
import { isTypeDisabled } from 'bundles/cml/editor/utils/elementUtils';
import { isMarkActive, toggleMark } from 'bundles/cml/editor/utils/markUtils';
import { getToolBarShortcutKey } from 'bundles/cml/editor/utils/toolbarUtils';
import { MARKS } from 'bundles/cml/shared/constants';

import _t from 'i18n!nls/cml';

const hasHeadingBoldVariant = () => {
  // TODO
  return false;
};

const BoldButton: React.FC = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const disabled = isTypeDisabled(editor, MARKS.BOLD);
  const active = isMarkActive(editor, MARKS.BOLD) || hasHeadingBoldVariant();

  const handleClick = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    () => toggleMark(staticEditor, MARKS.BOLD),
    [staticEditor]
  );

  const shortcutKey = getToolBarShortcutKey('B');
  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      active={active}
      className="rc-BoldButton"
      title={_t('Bold #{shortcutKey}', { shortcutKey })}
      type={TOOLBAR_BUTTON_TYPES.formatting}
    >
      <BoldIcon size="small" />
    </Button>
  );
};

export default BoldButton;
